import * as yup from 'yup';

import { http } from 'lib/services/http';
import { voiceBaseUrl } from 'constants/apiUrls';

const BASE_API_PATH = `${voiceBaseUrl}`;
// VSOS Hunt Group Swagger -- http://10.103.50.156:8080/swagger-ui.html#/Hunt-Groups

const teamObjectValidator = yup.object().shape({
  assignedProfiles: yup.array().of(yup.string()).optional(),
  teamId: yup.number().required(),
});

export const callWithHandler = async (fn, ...args) => {
  let data;
  let error;

  try {
    const response = await fn(...args);

    ({ data } = response);
  } catch (e) {
    error = e;
  }

  return { error, data };
};

export const getHuntGroups = ({ includeProfileInfo = false } = {}) => {
  return http.get(`${BASE_API_PATH}/hunt-groups`, {
    params: {
      includeProfileInfo,
    },
  });
};

export const createHuntGroup = (teamObj = {}) => {
  return teamObjectValidator.validate(teamObj).then(() => {
    return http.post(`${BASE_API_PATH}/hunt-groups`, teamObj);
  });
};

export const getVoiceMailData = (huntGroupId) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/voicemail/options`;

  return http.get(path);
};

export const updateVoiceMailData = (huntGroupId: string, options) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/voicemail/options`;

  return http.put(path, options);
};

export const updateActiveGreeting = (huntGroupId: string, greeting: string) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/voicemail/greeting`;

  return http.put(path, greeting);
};

export const deleteVoiceMailGreeting = (
  huntGroupId: string,
  greetingName: string,
) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/voicemail/greeting/${greetingName}`;

  return http.delete(path);
};

export const createNewGreeting = ({ huntGroupId, greetingName, formData }) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/voicemail/greeting/${greetingName}`;

  return http.post(path, formData);
};

export const getHuntGroupDistro = ({ huntGroupId }) => {
  const path = `${BASE_API_PATH}/hunt-groups/${huntGroupId}/call-distribution`;

  return http.get(path);
};
